/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

window.addEventListener('load', addCSSFromSheet);

// Update the shadow dom button for the 'dont miss out' button.
function addCSSFromSheet(params) {
  let giveUp = 0;  
  const buttonInt = setInterval(() => {
    const appEmbed = document.querySelector('#app-embed-container-242017');
    if (appEmbed) {
      const sheet = new CSSStyleSheet();
      sheet.replaceSync(`button {
        padding: 10px 15px !important;
        border-radius: 30px !important;
      }
      button h3[data-testid="teaser-message"] {
        font-size: 15px;
        font-family: 'Roboto';
        font-weight: 400;
      }
      @media screen and (max-width: 500px) {
        button[type="button"] {
          position: fixed;
          bottom: 90px;
          right: 8px;
        }
      }`);
      appEmbed.shadowRoot.adoptedStyleSheets.push(sheet);
      clearInterval(buttonInt);
    }
    else {
      giveUp++;
      if (giveUp == 100) {
        clearInterval(buttonInt);
      }
    }
  }, 100);
}
